













































import ContentTree from '@/components/ContentTree.vue';
import deck, { NextStepStarredItem } from '@/store/modules/deck';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'NextStepsSlide',
  components: {
    ContentTree,
  },
})
export default class NextStepsSlide extends Vue {
  overlayItem: NextStepStarredItem | null = null;

  get starredItems() {
    return deck.NextStepsStarred;
  }

  colorClass(index: number): number {
    return (index % 5) + 1;
  }

  openOverlay(item: NextStepStarredItem) {
    this.overlayItem = item;
  }

  closeOverlay() {
    this.overlayItem = null;
  }
}
